import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isFunction } from "lodash";

import { saveMessageForZenith } from "@services/message";

export function useCreateMessage(options: any = {}) {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = options;

  return useMutation<any, any, any>({
    mutationKey: ["create_message"],
    mutationFn: saveMessageForZenith,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notifications"] });

      if (isFunction(onSuccess)) {
        onSuccess();
      }
    },
    ...restOptions,
  });
}
